import { Centered, LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'
import { ChangePasswordForm } from 'components/core-v2/organisms/forms/change-password'

import classes from './index.module.scss'

export const ChangePasswordPage = () => (
  <LeftSideBar
    leftElement={<Navigation />}
    mainElement={
      <Centered className={classes.page}>
        <div className={classes.formWrapper}>
          <ChangePasswordForm />
        </div>
      </Centered>
    }
    topBarElement={<UserMenuTopBar />}
  />
)
